module.exports = __webpack_public_path__ + "static/media/react.4d0df56d.svg";